// extracted by mini-css-extract-plugin
export default {"cardsWrapper":"directories-list_cardsWrapper__GQvXM"};